import type { ReactElement } from "react";
import { useCallback } from "react";

import {
    StyledLeadsBaseContentContainer,
    StyledLeadsTabContent,
    StyledLeadsTableWrapper,
} from "app/pages/sales-intelligence/common-components/layout";
import { SearchResultsTableFallback } from "app/pages/sales-intelligence/common-components/search-results-table";
import type { TabContentComponentProps } from "app/pages/sales-intelligence/common-components/tabbed-page-content";
import type { PageTabBase } from "app/pages/sales-intelligence/common-components/tabbed-page-content/types";
import type { AppsSearchTableData } from "app/pages/sales-intelligence/modules/apps-search/types/table";
import FindAppsIosFiltersContainer from "app/pages/sales-intelligence/modules/find-apps-filters/containers/FindAppsIosFiltersContainer";
import { fromDtoToColumnsConfig } from "app/pages/sales-intelligence/modules/leads-search/utils";
import type { AppsSourceType } from "app/pages/sales-intelligence/store/find-apps/types/appsSourceType";
import type { IFindAppsIosRowDto, IFindAppsResponseDto } from "app/pages/sales-intelligence/store/find-apps/types/dto";

import { iosTableColumnConfig } from "../configuration/columns/iosColumnConfig";
import { useIosAppsData } from "../queries/useGetAppsData";

import FindAppsTableContainer from "./find-apps-table/FindAppsTableContainer";

const FindAppsIosTabContentContainer = ({
    shouldRenderDeferredContent = true,
}: TabContentComponentProps<PageTabBase<AppsSourceType>>): ReactElement => {
    const transformData = useCallback((data: IFindAppsResponseDto): AppsSearchTableData<IFindAppsIosRowDto> => {
        return { ...data, columns: fromDtoToColumnsConfig(data.columns, iosTableColumnConfig) };
    }, []);

    const { data, isFetching } = useIosAppsData(transformData);

    return (
        <StyledLeadsTabContent>
            <StyledLeadsBaseContentContainer>
                <FindAppsIosFiltersContainer />
            </StyledLeadsBaseContentContainer>

            <StyledLeadsTableWrapper>
                <SearchResultsTableFallback isVisible={!shouldRenderDeferredContent}>
                    <FindAppsTableContainer<IFindAppsIosRowDto>
                        isLoading={isFetching}
                        data={data}
                    />
                </SearchResultsTableFallback>
            </StyledLeadsTableWrapper>
        </StyledLeadsTabContent>
    );
};

export default FindAppsIosTabContentContainer;
